import {Edge} from './Edge';
import {ReadOnlyCollection} from './ReadOnlyCollection';

declare var THREE: any;

export class Edges extends ReadOnlyCollection<Edge> {

  constructor(edges: Array<Edge>) {
    super(edges);
  }

  static fromPoints(points: Array<any>): Edges {
    const result = [];
    for (let i = 0; i < points.length; i++) {
      const first = points[i];
      const second = points[(i + 1) % points.length];
      result.push(
        new Edge(
          new THREE.Vector3(first.x, 0, first.y),
          new THREE.Vector3(second.x, 0, second.y)
        )
      );
    }
    return new Edges(result);
  }

  static fromEdges(edges: Array<any>): Edges {
    const result = [];
    for (let i = 0; i < edges.length; i++) {
      const oldEdge = edges[i];
      const newEdge = new Edge(
        {x: oldEdge.firstPoint.x, z: oldEdge.firstPoint.y},
        {x: oldEdge.secondPoint.x, z: oldEdge.secondPoint.y}
      );
      if (oldEdge.firstPoint.superstructureId) {
        const holeDistanceFromStartPoint = oldEdge.firstPoint.distance;
        const holeLength = oldEdge.firstPoint.width;
        const holePosition = newEdge.start
          .add(newEdge.direction.multiplyScalar(holeDistanceFromStartPoint));
        const end = holePosition
          .clone()
          .add(newEdge.direction.multiplyScalar(holeLength / 2));
        const start = holePosition
          .clone()
          .add(newEdge.direction.negate().multiplyScalar(holeLength / 2));
        newEdge.addHole(start, end);
      }
      const edgeHasTier = oldEdge.firstPoint.superstructureType
        && (oldEdge.firstPoint.superstructureType.indexOf('tier') === 0 ||
          oldEdge.firstPoint.superstructureType === 'wall');
      newEdge.hidden = edgeHasTier || false;

      result.push(newEdge);
    }
    return new Edges(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/Edges.ts